import {useState} from "react";

const useSearchBar = () => {
    const [filter, setFilter] = useState()
    const [items] = useState([])

    return {filter, setFilter, items}
}


export default useSearchBar